import {
  EMBARGO_MESSAGE_KEYS,
  EMBARGO_MODES,
  EMBARGO_VALIDATION_TYPES,
} from './constants';
import type { EmbargoMessageKey, EmbargoMode, EmbargoValidationType } from './types';

type ModeAwareMessage =
  | string
  | {
      [EMBARGO_MODES.CREATE]: string;
      [EMBARGO_MODES.EDIT]: string;
      [EMBARGO_MODES.PROCESS]: string;
    };

export const EMBARGO_CONTENT = {
  banner: {
    createTitle: 'Pickup Creation Blocked',
    editTitle: 'Pickup Edit Blocked',
    processTitle: 'Pickup Processing Blocked',
    createWarningTitle: 'Pickup Creation Warning',
    editWarningTitle: 'Pickup Edit Warning',
    processWarningTitle: 'Pickup Processing Warning',
  },
  messages: {
    [EMBARGO_MESSAGE_KEYS.NON_SERVICE_ZIP]: {
      [EMBARGO_MODES.CREATE]:
        'The destination zip is currently under embargo.',
      [EMBARGO_MODES.EDIT]:
        'The destination zip is currently under embargo.',
      [EMBARGO_MODES.PROCESS]:
        'The destination zip is currently under embargo.',
    },
    [EMBARGO_MESSAGE_KEYS.FREEZABLE_LANE_BY_ZIP]: {
      [EMBARGO_MODES.CREATE]:
        "Freezable shipments are currently not accepted at this destination zip.",
      [EMBARGO_MODES.EDIT]:
        "Freezable shipments are currently not accepted at this destination zip.",
      [EMBARGO_MODES.PROCESS]:
        'The destination zip is not currently accepting freezable shipments.',
    },
    [EMBARGO_MESSAGE_KEYS.FREEZABLE_LANE_BY_TERMINAL]:
      "Freezable shipments are currently not accepted at this destination terminal.",
  } as Record<EmbargoMessageKey, ModeAwareMessage>,
  saveError: {
    defaultDescription: 'This pickup cannot be saved due to an embargo restriction.',
  },
  logging: {
    loadFailed: 'Failed to load embargo / pickup restriction lists',
  },
} as const;

export const getEmbargoBannerTitle = (
  mode: EmbargoMode,
  validationType: EmbargoValidationType = EMBARGO_VALIDATION_TYPES.ERROR
): string => {
  const isWarning = validationType === EMBARGO_VALIDATION_TYPES.WARNING;
  if (mode === EMBARGO_MODES.PROCESS) {
    return isWarning
      ? EMBARGO_CONTENT.banner.processWarningTitle
      : EMBARGO_CONTENT.banner.processTitle;
  }
  if (mode === EMBARGO_MODES.EDIT) {
    return isWarning
      ? EMBARGO_CONTENT.banner.editWarningTitle
      : EMBARGO_CONTENT.banner.editTitle;
  }
  return isWarning
    ? EMBARGO_CONTENT.banner.createWarningTitle
    : EMBARGO_CONTENT.banner.createTitle;
};

const resolveModeAwareMessage = (
  message: ModeAwareMessage,
  mode: EmbargoMode
): string => {
  if (typeof message === 'string') {
    return message;
  }
  return message[mode];
};

export const getEmbargoMessage = (
  messageKey: EmbargoMessageKey,
  mode: EmbargoMode = EMBARGO_MODES.CREATE
): string => resolveModeAwareMessage(EMBARGO_CONTENT.messages[messageKey], mode);
